import React, { useEffect, useState } from "react";
import "./App.css";
import Footer from './Footer';
import logoImage from "./images/WazzaScore_Logo2.png";

const legalFiles = [
  { name: "End User License Agreement", file: "EULA.txt", id: "eula" },
  { name: "Privacy Policy", file: "Privacy-Policy.txt", id: "privacy-policy" },
  { name: "Terms and Conditions", file: "TermsAndConditions.txt", id: "terms" },
  { name: "Promotion of Access to Information", file: "PAIA.txt", id: "PAIA" },
];

function CombinedLegal() {
  const [legalTexts, setLegalTexts] = useState({});
  const [showScrollButton, setShowScrollButton] = useState(false); // State for back-to-top button visibility

  useEffect(() => {
    // Fetch legal files
    legalFiles.forEach(async ({ file }) => {
      try {
        const res = await fetch(`/${file}`);
        if (res.ok) {
          const text = await res.text();
          setLegalTexts((prev) => ({ ...prev, [file]: text }));
        } else {
          setLegalTexts((prev) => ({ ...prev, [file]: "Failed to load document." }));
        }
      } catch (error) {
        setLegalTexts((prev) => ({ ...prev, [file]: "Error loading document." }));
      }
    });

    // Scroll event listener for back-to-top button visibility
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll); // Cleanup event listener
  }, []);

  // Function to scroll back to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="privacy-policy">
      <header className="privacyHeader">
        <div className="smallLogo">
          <a href="/">
            <img
              src={logoImage}
              alt="WazzaScore Logo"
              style={{ width: "25%", height: "auto", maxWidth: "100%", cursor: "pointer" }}
            />
          </a>
        </div>
      </header>

      <main className="legalContent" style={{ padding: "2rem", maxWidth: "100%", margin: "0 auto" }}>
        <h1 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "1.5rem" }}>
          Legal Information
        </h1>

        {/* Section Links */}
        <nav style={{ marginBottom: "2rem", textAlign: "center" }}>
          {legalFiles.map(({ name, id }) => (
            <a
              key={id}
              href={`#${id}`}
              style={{
                margin: "0 1rem",
                textDecoration: "none",
                color: "#007BFF",
                fontWeight: "bold",
              }}
            >
              {name}
            </a>
          ))}
        </nav>

        {/* Legal Sections */}
        {legalFiles.map(({ name, file, id }) => (
          <section key={file} id={id} style={{ marginBottom: "3rem" }}>
            <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>{name}</h2>
            <pre style={{ 
              whiteSpace: "pre-wrap", 
              fontSize: "0.95rem", 
              lineHeight: "1.6", 
              color: "#444", 
              background: "#f9f9f9",
              padding: "1rem",
              borderRadius: "8px",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)"
            }}>
              {legalTexts[file] || "Loading..."}
            </pre>
          </section>
        ))}
      </main>

      {/* Back-to-Top Button */}
      {showScrollButton && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#1cac53",
            color: "#fff",
            borderRadius: "50%",
            border: "none",
            width: "50px",
            height: "50px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            cursor: "pointer",
            fontSize: "20px",
          }}
          title="Back to Top"
        >
          ↑
        </button>
      )}

      <Footer />
    </div>
  );
}

export default CombinedLegal;
